import { render, staticRenderFns } from "./SendPaper.vue?vue&type=template&id=2f8e97b2&scoped=true&"
import script from "./SendPaper.vue?vue&type=script&lang=js&"
export * from "./SendPaper.vue?vue&type=script&lang=js&"
import style0 from "./SendPaper.vue?vue&type=style&index=0&id=2f8e97b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8e97b2",
  null
  
)

export default component.exports